<template>
  <div class="celular-detalhado-imagem">
    <template v-if="!!imagem">
      <transition name="fade">
        <img v-show="isLoad" :src="url" @load="loaded" />
      </transition>
      <div class="loading-img" v-show="!isLoad">
        <img id="img" src="@/assets/imgs/puff.svg" alt="Loading...." />
      </div>
    </template>
    <img v-else src="@/assets/vivo-consulta/imagens/generic_phone_teaser.png" />
  </div>
</template>

<script>
export default {
  name: 'CelularDetalhadoImagem',
  props: {
    imagem: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    url: '',
    isLoad: false,
  }),
  created() {
    this.loadImage();
  },
  methods: {
    loadImage() {
      this.isLoad = false;
      this.url = this.imagem;
    },
    loaded() {
      this.isLoad = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.loading-img {
  width: 100%;
  height: 180px;
  display: flex;
  justify-content: center;
  align-items: center;
  & #img {
    height: 60px;
  }
}

.celular-detalhado-imagem {
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  width: 100%;
  max-width: 100%;
  height: 300px;
  padding: 0 16px;
  & img {
    user-select: none;
    object-fit: contain;
    max-width: 100%;
    max-height: 300px;
    width: auto;
    height: auto;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
